import { render, staticRenderFns } from "./Index-compras.vue?vue&type=template&id=1cea15d8&scoped=true"
import script from "./Index-compras.vue?vue&type=script&lang=js"
export * from "./Index-compras.vue?vue&type=script&lang=js"
import style0 from "./Index-compras.vue?vue&type=style&index=0&id=1cea15d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea15d8",
  null
  
)

export default component.exports